// @flow
import React from 'react';
import type {Node} from 'react';
import {DatePicker, Select, Stack, Typography} from '@wellstone-solutions/web';
import type {ApiProgramAdmissionType} from '@wellstone-solutions/common/dist/models/types';

type SelectedItemType = {
  id: string,
  startDate: string,
  endDate: string,
};

type PropTypes = {
  selectOptions: Array<{label: string, value: any}>,
  admission: SelectedItemType,
  setAdmission: (params: SelectedItemType) => void,
  label: string,
  programAdmission: ApiProgramAdmissionType,
};

export const ItemSelection = ({
  setAdmission,
  admission,
  selectOptions,
  label,
  programAdmission,
}: PropTypes): Node => {
  const handleChange = (evt) => {
    setAdmission({...admission, id: evt.target.value});
  };

  return (
    <div style={styles.selectContainer}>
      <Stack direction="column">
        {selectOptions.length > 0 ? (
          <>
            <Select
              label={label}
              items={selectOptions}
              value={admission.id}
              onChange={handleChange}
              data-testid="select-item"
            />
            <Stack sx={{pt: 2}} direction="row" justifyContent="space-between">
              <DatePicker
                label="Start Date"
                fieldName="admissionStart"
                onChange={(date) => {
                  setAdmission({
                    ...admission,
                    startDate: date?.isValid() ? date.toISOString() : '',
                  });
                }}
                value={admission.startDate}
                minDate={programAdmission?.start_date}
              />
              <DatePicker
                label="(Estimated) End Date"
                fieldName="admissionEnd"
                onChange={(date) => {
                  setAdmission({
                    ...admission,
                    endDate: date?.isValid() ? date.toISOString() : '',
                  });
                }}
                value={admission.endDate}
                maxDate={programAdmission?.end_date}
              />
            </Stack>
          </>
        ) : (
          <Typography>{`No additional ${label.toLowerCase()} to add.`}</Typography>
        )}
      </Stack>
    </div>
  );
};

const styles = {
  selectContainer: {
    marginBottom: '30px',
  },
};
